import { useQuery } from '@tanstack/react-query'
import _ from 'lodash'

import { getUpcomingAppointments } from 'services/graphQLCloudService'
import filterAndProcessAppointments from 'helpers/apptsFilterUtils'
import { appointmentsKeys } from './keys'
import { APPOINTMENTS_RETRY } from './retry'

const fetchAndProcessUpcomingAppointments = async ({
  patientId,
  token,
  dependentAccount
}) => {
  const data = await getUpcomingAppointments(patientId, token)
  const processed = filterAndProcessAppointments(
    _.get(data, 'appointmentLookup.appointments'),
    'appointmentLookup',
    dependentAccount
  )
  const sorted = _.orderBy(processed, ['datetime'], ['asc'])
  return {
    ...data,
    appointmentLookup: {
      ..._.get(data, 'appointmentLookup', {}),
      appointments: sorted
    }
  }
}

export const useGetUpcomingAppointments = ({
  patientId,
  token,
  dependentAccount = null,
  useQueryOptions = {}
}) => {
  return useQuery({
    queryKey: appointmentsKeys.upcoming(patientId, dependentAccount),
    queryFn: () =>
      fetchAndProcessUpcomingAppointments({
        patientId,
        token,
        dependentAccount
      }),
    enabled: Boolean(patientId),
    staleTime: 30_000,
    refetchOnMount: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...APPOINTMENTS_RETRY,
    ...useQueryOptions
  })
}
